import { userService } from "../../services/user.service";
import { User } from "../../models/user.model";

// tslint:disable-next-line:typedef
const state = {
};

// tslint:disable-next-line:typedef
const actions = {
    setUserAvailability: ({commit, dispatch}: {commit: any, dispatch: any}, user: User) => {
        userService.setAvailability(user).then((result)=> {
            // alert("DONE");
        });
    }
};

export default {
    state,
    actions,
};

